/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';

import styles from '@styles/confirmation/congratulation.module.scss';

const ShareProduct = () => {
	const navigator = useRouter();

	const productUrl = process.env.SITE_URL + navigator.asPath;

	return (
        <div className='bidSecRtShare'>
            <div className={styles.socialSecRt}>
				<div className='d-flex'>
					<span>Share</span>
					<span>
						<Link
                            href={`mailto:info@example.com?&subject=&cc=&bcc=&body=${productUrl}`}
                            target='_blank'>

                            <img
                                src={'/assets/svg/mail.svg'}
                                alt={'box'}
                                style={{width: '25px', height: '100%'}}
                            />

                        </Link>
					</span>
					<span>
						<Link
                            href={`https://www.facebook.com/sharer/sharer.php?u=${productUrl}`}
                            target='_blank'>

                            <img
                                src={'/assets/svg/facebook.svg'}
                                alt={'box'}
                                style={{width: '25px', height: '100%'}}
                            />

                        </Link>
					</span>
					<span>
						<Link
                            href={`https://twitter.com/intent/tweet?url=${productUrl}`}
                            target='_blank'>

                            <img
                                src={'/assets/svg/twitter.svg'}
                                alt={'box'}
                                style={{width: '25px', height: '100%'}}
                            />

                        </Link>
					</span>
				</div>
			</div>
        </div>
    );
};

export default ShareProduct;
